<template>
    <div>
        <v-text-field
            :readonly="$vuetify.breakpoint.xs || readonly"
            :label="label"
            :loading="loading"
            :disabled="disabled"
            :outline="outline"
            :rules="rules"
            :error-messages="errorMessages"
            :error="error"
            v-model="dateFormatted"
            prepend-inner-icon="event"
            @input="updateDate()"
            @click="openIfMobile"
            @blur="date = parseDate(dateFormatted)"
            @keyup="event => $emit('keyup', event)"
            @click:prepend-inner="iconClicked"
            :required="isRequired"
            mask="##.##.####"
            return-masked-value
            ref="picker"
        ></v-text-field>
        <v-menu
                ref="menu"
                lazy
                :close-on-content-click="false"
                v-model="menu"
                transition="scale-transition"
                offset-y
                full-width
                absolute
                :position-x="x"
                :position-y="y"
                right
                bottom
                :nudge-right="40"
                :disabled="disabled"
                max-width="290px"
                min-width="290px"
        >
            <v-date-picker
                    ref="picker"
                    v-model="date"
                    @input="dateFormatted = formatDate($event); updateDate();"
                    :first-day-of-week="picker.firstDayOfWeek"
                    :locale="picker.locale"
                    :disabled="disabled"
                    :allowed-dates="allowedDates"
                    :min="min"
                    :max="max"
                    scrollable
                    actions>
            </v-date-picker>
        </v-menu>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                date: null,
                dateFormatted: '',
                picker: {
                    locale: 'de-de',
                    firstDayOfWeek: 1
                },
                menu: false,
                x: 0,
                y: 0,
                textFieldRect: null,
                isRequired: false
            }
        },
        watch: {
            value: function (val) {
                this.setDate(val);
            },
            menu(val) {
                if (!this.value && this.birthDate !== undefined && this.birthDate === true) {
                    val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'));
                }
            },
            dateFormatted() {
                if (this.dateFormatted === '') {
                    this.date = null;
                }
            },
            date() {
                this.$emit('update:value', this.date);
            }
        },
        props: {
            value: {
                type: String,
                default: null
            },
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            birthDate: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            error: {
                type: Boolean,
                default: false
            },
            outline: {
                type: Boolean,
                default: false
            },
            rules: {
                type: Array,
                default: null
            },
            errorMessages: {
                type: Array,
                default: () => []
            },
            allowedDates: {
                type: Array,
                default: null
            },
            max: {
                type: String,
                default: null
            },
            min: {
                type: String,
                default: null
            }
        },
        mounted() {
            this.setLocale(this.getLocale());

            this.setDate(this.value);

            if (this.required !== undefined && this.required !== false) {
                this.isRequired = true;
            }
        },
        methods: {
            openIfMobile() {
                if (this.$vuetify.breakpoint.xs) {
                    this.iconClicked();
                }
            },
            iconClicked() {
                if (this.disabled) {
                    return;
                }

                if (this.textFieldRect === null) {
                    this.textFieldRect = this.$refs.picker.$refs.input.getBoundingClientRect();
                }

                this.x = this.textFieldRect.x - 40;
                this.y = this.textFieldRect.y;
                this.menu = !this.menu;
            },
            updateDate() {
                if (/\d{2}.\d{2}.\d{4}$/.test(this.dateFormatted)) {
                    this.date = this.parseDate(this.dateFormatted);
                }
                this.$emit('input', this.date);
            },
            setDate(value) {
                this.date = value;

                if (this.date) {
                    if (/\s\d{2}:\d{2}:\d{2}$/.test(this.date)) {
                        this.date = this.date.replace(/\s\d{2}:\d{2}:\d{2}$/, '');
                    }

                    this.dateFormatted = this.formatDate(this.date);
                } else {
                    this.dateFormatted = '';
                }
            },
            formatDate (date) {
                if (!date) {
                    return null
                }

                const [year, month, day] = date.split('-');

                switch (this.getLocale()) {
                    case 'de':
                        return `${day}.${month}.${year}`;
                    default:
                        return date;
                }
            },
            parseDate (date) {
                if (!date) {
                    return null
                }

                if (this.getLocale() === 'de') {
                    let [day, month, year] = date.split('.');

                    if (!day || !month || !year) {
                        return null;
                    }

                    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                }

                return date;
            },
            getLocale() {
                return localStorage.getItem('locale');
            },
            setLocale(locale) {
                switch (locale) {
                    case 'de':
                        this.picker.locale = 'de-de';
                        this.picker.firstDayOfWeek = 1;
                        break;
                    case 'en':
                        this.picker.locale = 'en-en';
                        this.picker.firstDayOfWeek = 0;
                        break;
                    default:
                        this.picker.firstDayOfWeek = 1;
                        this.picker.locale = 'de-de';
                }
            }
        }
    }
</script>